/* ============================================================
   MCC R1 (10/2026) · R1.2 — PHONE FILTER & SORT
   mcc-mobile-filters.js  (loaded with defer by snippets/mcc-mobile-filter-bar.liquid)

   Phones only (< 750px). At 750px and up this script undoes everything it did, so tablet and desktop
   behave exactly as before.

   1. Bottom sheet. The page's own filter sidebar (<aside class="mcc-xx-sidebar">) and the sidebar's
      sort box are MOVED into the sheet on phones and back to their original place when the screen
      gets wider. Moving keeps every listener the sidebar snippets attached (they bind by class), so
      links, checkboxes and sort work exactly as today; filter taps still navigate straight away.
   2. Sort on general pages (the general sidebar has none): the sheet's own select.
   3. Load more: fetches the next page of the grid section and appends its cards under the existing
      <ul id="product-grid">. Never touches the address bar or history (facets.js re-renders the grid
      on popstate), and uses event delegation so it survives facets.js replacing the grid.
      A failed request is retried once; if the server still doesn't send the grid, the shopper is taken
      to the next page through the bottom page numbers instead (round 3).

   A tap on "Filter & Sort" before this file is set up (slow phones) is queued by the inline script in
   mcc-mobile-filter-bar.liquid and honoured by startSheet() (round 3).

   While the sheet is open, html.mcc-msheet-open is set: mcc-mobile-filters.css uses it to hide the
   Smile.io "Rewards" launcher, which otherwise sits on top of the sheet's "Show results" button.

   Theme editor: when the grid section is re-rendered (shopify:section:unload / :load), the old sheet is
   removed and the new section's bar and sidebar are set up again.

   Fails safe: any error removes html.mcc-mf-on, which puts the page back to today's layout. (If this
   file never runs at all, the inline script in mcc-mobile-filter-bar.liquid removes it on window load:
   it checks window.__mccMobileFilters, set on the first line below.)
   ============================================================ */
(function () {
  'use strict';

  if (window.__mccMobileFilters) return;
  window.__mccMobileFilters = true;

  var ROOT = document.documentElement;
  var ON = 'mcc-mf-on';
  var SHEET_OPEN = 'mcc-msheet-open';
  var PHONE = '(max-width: 749px)';
  var SIDEBARS = '.mcc-of-sidebar, .mcc-wf-sidebar, .mcc-ff-sidebar, .mcc-dc-sidebar, .mcc-lt-sidebar, .mcc-tr-sidebar, .mcc-rf-sidebar, .mcc-gf-sidebar';
  var SORTS = '.mcc-of-sort, .mcc-wf-sort, .mcc-ff-sort, .mcc-dc-sort, .mcc-lt-sort, .mcc-tr-sort, .mcc-rf-sort';
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

  function push(data) {
    try {
      (window.dataLayer = window.dataLayer || []).push(data);
    } catch (e) {}
  }

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function isShown(el) {
    return !!(el && (el.offsetWidth > 0 || el.offsetHeight > 0));
  }

  function firstShown(list) {
    for (var i = 0; i < list.length; i++) {
      if (isShown(list[i])) return list[i];
    }
    return null;
  }

  function focusQuietly(el) {
    if (!el) return;
    try {
      el.focus({ preventScroll: true });
    } catch (e) {}
  }

  /* Remembers where a node came from (a comment placeholder) so it can be put back exactly there. */
  function Mover(node) {
    this.node = node;
    this.home = document.createComment(' mcc-mf: original place ');
    node.parentNode.insertBefore(this.home, node);
  }
  Mover.prototype.into = function (slot) {
    if (this.node.parentNode !== slot) slot.appendChild(this.node);
  };
  Mover.prototype.back = function () {
    var home = this.home;
    if (home.parentNode && home.nextSibling !== this.node) {
      home.parentNode.insertBefore(this.node, home.nextSibling);
    }
  };

  /* ---------------------------------------------------------------- sheet */
  // Returns a controller ({ bar, destroy }) or null when this page has no bar / sidebar to work with.
  function initSheet() {
    var bar = document.querySelector('[data-mcc-mfb]');
    if (!bar) return null;
    var section = bar.closest('.shopify-section') || document;
    // The sheet is printed next to the bar; look there first (in the theme editor an old, portalled
    // sheet can still be in <body> for a moment after the section was re-rendered).
    var sheet = section.querySelector('[data-mcc-msheet]') || document.getElementById('mcc-msheet');
    if (!sheet) return null;

    var openBtn = bar.querySelector('[data-mcc-open]');
    var panel = sheet.querySelector('[data-mcc-panel]');
    var filterSlot = sheet.querySelector('[data-mcc-filter-slot]');
    var sortSlot = sheet.querySelector('[data-mcc-sort-slot]');
    var sidebar = section.querySelector(SIDEBARS);
    if (!openBtn || !panel || !filterSlot || !sortSlot || !sidebar) return null;

    var sortBox = section.querySelector(SORTS);
    var sidebarMover = new Mover(sidebar);
    var sortMover = sortBox ? new Mover(sortBox) : null;

    // Out of the section: no transformed / animated ancestor (.scroll-trigger) can trap the fixed sheet.
    document.body.appendChild(sheet);

    var mq = window.matchMedia(PHONE);
    var isOpen = false;
    var hideTimer = null;
    var returnFocus = null;

    function focusables() {
      return Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
      });
    }

    function onKeydown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        close();
        return;
      }
      if (e.key !== 'Tab') return;
      var list = focusables();
      if (!list.length) {
        e.preventDefault();
        panel.focus();
        return;
      }
      var first = list[0];
      var last = list[list.length - 1];
      var active = document.activeElement;
      if (e.shiftKey && (active === first || active === panel || !panel.contains(active))) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && (active === last || !panel.contains(active))) {
        e.preventDefault();
        first.focus();
      }
    }

    function open() {
      if (isOpen || !mq.matches) return;
      isOpen = true;
      clearTimeout(hideTimer);
      // Where focus goes back on close. Safari/iOS does not focus a button that is tapped, so
      // activeElement is usually <body> there: fall back to the "Filter & Sort" button.
      var active = document.activeElement;
      returnFocus = active && active !== document.body && active !== ROOT && !sheet.contains(active) ? active : openBtn;
      sheet.hidden = false;
      void sheet.offsetWidth; // start the slide-up from the closed position
      sheet.classList.add('is-open');
      ROOT.classList.add(SHEET_OPEN); // hides the Smile.io launcher (mcc-mobile-filters.css)
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('overflow-hidden-mobile');
      document.addEventListener('keydown', onKeydown, true);
      var x = panel.querySelector('.mcc-msheet__x');
      (x || panel).focus({ preventScroll: true });
      push({ event: 'mcc_filter_sheet_open' });
    }

    function close(instant) {
      if (!isOpen) return;
      isOpen = false;
      sheet.classList.remove('is-open');
      ROOT.classList.remove(SHEET_OPEN);
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('overflow-hidden-mobile');
      document.removeEventListener('keydown', onKeydown, true);
      clearTimeout(hideTimer);
      if (instant === true || prefersReducedMotion()) {
        sheet.hidden = true;
      } else {
        hideTimer = setTimeout(function () {
          if (!isOpen) sheet.hidden = true;
        }, 280);
      }
      if (instant !== true) {
        focusQuietly(returnFocus && document.contains(returnFocus) && isShown(returnFocus) ? returnFocus : openBtn);
      }
      returnFocus = null;
    }

    // Dims the sheet while the next page loads. Cleared again after 10s in case the navigation never
    // happens (offline, or a handler that changed its mind), so the sheet can't stay locked.
    var busyTimer = null;
    function setBusy() {
      panel.setAttribute('aria-busy', 'true');
      clearTimeout(busyTimer);
      busyTimer = setTimeout(function () {
        panel.removeAttribute('aria-busy');
      }, 10000);
    }

    function apply() {
      if (mq.matches) {
        ROOT.classList.add(ON);
        sidebarMover.into(filterSlot);
        if (sortMover) sortMover.into(sortSlot);
      } else {
        // The screen got wider with the sheet open (tablet rotated, window widened). Moving the sidebar
        // back drops focus, so put it back on the same control in the page, or on the first control of
        // the sidebar if focus was on the sheet's own buttons (which are now hidden).
        var active = document.activeElement;
        var hadFocus = isOpen && !!active && sheet.contains(active);
        close(true);
        sidebarMover.back();
        if (sortMover) sortMover.back();
        ROOT.classList.remove(ON);
        if (hadFocus) {
          var target = document.contains(active) && !sheet.contains(active) && isShown(active) ? active : null;
          if (!target) target = firstShown(sidebar.querySelectorAll(FOCUSABLE));
          if (!target && sortBox) target = firstShown(sortBox.querySelectorAll(FOCUSABLE));
          focusQuietly(target);
        }
      }
    }

    openBtn.addEventListener('click', function (e) {
      e.preventDefault();
      open();
    });

    sheet.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-mcc-close]')) {
        e.preventDefault();
        close();
        return;
      }
      // A filter link or "Clear all" navigates (through the sidebar snippet's own click handler, or as a
      // plain link): show that the results are loading. In-page (#) links are left alone.
      var a = t.closest('a[href]');
      if (a) {
        var href = a.getAttribute('href') || '';
        if (href && href.charAt(0) !== '#' && href.indexOf('javascript:') !== 0) setBusy();
      }
    });

    sheet.addEventListener('change', function (e) {
      var t = e.target;
      if (!t.matches || !t.matches('input, select')) return;
      setBusy();
      // General pages: the sheet's own sort select (category sidebars bring their own handler).
      if (t.matches('[data-mcc-sort]')) {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', t.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      }
    });

    // Back/forward cache: the page can come back exactly as it was left (sheet open, busy).
    function onPageshow(e) {
      if (e.persisted) {
        panel.removeAttribute('aria-busy');
        close(true);
      }
    }
    window.addEventListener('pageshow', onPageshow);

    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);

    apply();

    return {
      bar: bar,
      open: open,
      // Theme editor only: the section is about to be replaced. Its new HTML brings a new bar, sheet and
      // sidebar; this one (portalled to <body>, so outside the section) must go.
      destroy: function () {
        close(true);
        clearTimeout(busyTimer);
        if (mq.removeEventListener) mq.removeEventListener('change', apply);
        else if (mq.removeListener) mq.removeListener(apply);
        window.removeEventListener('pageshow', onPageshow);
        if (sheet.parentNode) sheet.parentNode.removeChild(sheet);
        ROOT.classList.remove(ON);
        ROOT.classList.remove(SHEET_OPEN);
      }
    };
  }

  // A queued early tap older than this is dropped (the shopper has likely moved on).
  var PENDING_MAX_MS = 10000;

  var sheetCtl = null;
  function startSheet() {
    sheetCtl = initSheet();
    if (!sheetCtl) ROOT.classList.remove(ON);
    // "Filter & Sort" tapped before this file was ready: the inline script in mcc-mobile-filter-bar.liquid
    // queued it (window.__mccMfPending = time of the tap). From here on the button's own handler takes
    // over (__mccMfReady stops the queue). open() does nothing above 749px.
    var pending = window.__mccMfPending;
    window.__mccMfPending = 0;
    window.__mccMfReady = true;
    if (sheetCtl && pending && Date.now() - pending < PENDING_MAX_MS) sheetCtl.open();
  }

  /* ---------------------------------------------------------------- theme editor */
  // Changing a setting of the grid section in the customizer re-renders it: Shopify fires
  // shopify:section:unload on the old section, swaps in the new HTML, then fires shopify:section:load.
  // This file only boots once per page, so tear the sheet down and set it up again for the new HTML.
  // (These events only fire inside the theme editor.)
  function initEditor() {
    document.addEventListener('shopify:section:unload', function (e) {
      try {
        if (sheetCtl && e.target && e.target.contains && e.target.contains(sheetCtl.bar)) {
          sheetCtl.destroy();
          sheetCtl = null;
        }
      } catch (err) {
        ROOT.classList.remove(ON);
      }
    });
    document.addEventListener('shopify:section:load', function (e) {
      try {
        if (!e.target || !e.target.querySelector || !e.target.querySelector('[data-mcc-mfb]')) return;
        if (sheetCtl) {
          if (document.contains(sheetCtl.bar)) return;
          sheetCtl.destroy();
          sheetCtl = null;
        }
        startSheet();
      } catch (err) {
        ROOT.classList.remove(ON);
        if (window.console && console.error) console.error('[mcc-mobile-filters]', err);
      }
    });
  }

  /* ---------------------------------------------------------------- load more */
  // Identity of a card for de-duplication: the product id at the end of Dawn's card link id
  // (CardLink-<section id>-<product id>), else the product URL path.
  function productIdOf(li) {
    var a = li.querySelector('a[id^="CardLink-"]');
    if (a) {
      var parts = a.id.split('-');
      if (parts[parts.length - 1]) return parts[parts.length - 1];
    }
    var p = li.querySelector('a[href*="/products/"]');
    if (!p) return null;
    try {
      return new URL(p.getAttribute('href'), window.location.href).pathname;
    } catch (e) {
      return null;
    }
  }

  // The fetched section was requested with ?section_id=…, and its page links can carry it too; such a
  // link would open the bare section HTML instead of the page, so drop the parameter from every link.
  function stripSectionId(root) {
    Array.prototype.forEach.call(root.querySelectorAll('a[href*="section_id="]'), function (a) {
      try {
        var u = new URL(a.getAttribute('href'), window.location.href);
        u.searchParams.delete('section_id');
        a.setAttribute('href', u.pathname + u.search + u.hash);
      } catch (e) {}
    });
  }

  // A failed page request is tried once more after this pause (QA round 2 saw one stray 404).
  var RETRY_MS = 500;

  function badResponse(message) {
    var err = new Error(message);
    err.mccBadResponse = true; // the server answered, but not with the grid section
    return err;
  }

  // Fetches one page of the grid section and parses it. A non-OK status, or a 200 without the grid
  // (the section always prints an element with id="product-grid", even when empty), is a bad response.
  // Any failure (bad response or network) is retried once after RETRY_MS; the retry's error is final.
  function requestPage(url, isRetry) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw badResponse('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        if (!doc.getElementById('product-grid')) throw badResponse('no #product-grid in the response');
        return doc;
      })
      .catch(function (err) {
        if (isRetry) throw err;
        return new Promise(function (resolve) {
          setTimeout(resolve, RETRY_MS);
        }).then(function () {
          return requestPage(url, true);
        });
      });
  }

  function loadMore(box, btn) {
    if (box.getAttribute('data-busy') === 'true') return;
    var grid = document.getElementById('product-grid');
    if (!grid || grid.tagName !== 'UL') return;

    var sectionId = box.getAttribute('data-section-id') || grid.getAttribute('data-id');
    var next = parseInt(box.getAttribute('data-next'), 10);
    var last = parseInt(box.getAttribute('data-pages'), 10);
    var status = box.querySelector('[data-mcc-loadmore-status]');
    var label = box.querySelector('[data-mcc-loadmore-label]');
    if (!sectionId || !(next > 0) || !(last > 0)) return;

    var seen = {};
    Array.prototype.forEach.call(grid.children, function (li) {
      var id = productIdOf(li);
      if (id) seen[id] = true;
    });

    var firstNew = null;
    var added = 0;
    var hops = 0;

    box.setAttribute('data-busy', 'true');
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Loading…';
    if (status) {
      status.classList.remove('is-error');
      status.classList.add('visually-hidden');
      status.textContent = '';
    }

    function finish(error) {
      box.removeAttribute('data-busy');
      btn.removeAttribute('aria-busy');
      if (label) label.textContent = 'Load more';
      box.setAttribute('data-next', String(next));

      if (error) {
        btn.disabled = false;
        if (status) {
          status.textContent = "Couldn't load more products. Please try again.";
          status.classList.remove('visually-hidden');
          status.classList.add('is-error');
        }
        return;
      }

      var done = next > last;
      if (status) {
        status.textContent = (added === 1 ? '1 more product loaded.' : added + ' more products loaded.') +
          (done ? ' That is everything in this list.' : '');
      }
      var hadFocus = document.activeElement === btn;
      if (done) {
        btn.hidden = true;
      } else {
        btn.disabled = false;
      }
      // If the button just disappeared under the shopper's focus, keep focus on the new products.
      if (hadFocus && done && firstNew) {
        var link = firstNew.querySelector('a[href]');
        if (link) {
          try {
            link.focus({ preventScroll: true });
          } catch (e) {}
        }
      }
      push({ event: 'mcc_load_more', mcc_page: next - 1, mcc_added: added });
    }

    // Last resort when the section request failed twice with a server answer: open the next page the
    // normal way, by clicking the bottom page numbers' "Next page" link (it shows the page after the last
    // one loaded). A real click, not location.assign(), so layout/theme.liquid's click script adds the
    // in-stock filter exactly as when a shopper taps that link; without it, that script's arrival check
    // would re-request the page without `page` and the shopper would land on page 1 again.
    function goToNextPage() {
      var bar = box.parentNode ? box.parentNode.querySelector('.mcc-pgbar--bottom') : null;
      var link = bar ? bar.querySelector('a.mcc-pgbar__pg--arrow[aria-label="Next page"]') : null;
      if (link && link.origin !== window.location.origin) link = null;
      if (!link) {
        // No usable link: the same URL with the next page number, through a hidden link of our own.
        var url = new URL(window.location.href);
        url.searchParams.set('page', String(next));
        url.searchParams.delete('section_id');
        link = document.createElement('a');
        link.href = url.pathname + url.search;
        link.hidden = true;
        box.appendChild(link);
      }
      if (status) status.textContent = 'Opening page ' + next + '…';
      link.click();
    }

    function step() {
      // Pages can come back empty: the theme hides out-of-stock / imageless products after paging.
      if (added > 0 || next > last || hops >= 3) {
        finish(false);
        return;
      }
      var params = new URLSearchParams(window.location.search); // keeps sort_by, per_page, filters
      params.set('page', String(next));
      params.set('section_id', sectionId);
      requestPage(window.location.pathname + '?' + params.toString(), false)
        .then(function (doc) {
          var items = doc.querySelectorAll('#product-grid > li.grid__item');
          var frag = document.createDocumentFragment();
          Array.prototype.forEach.call(items, function (li) {
            var id = productIdOf(li);
            if (id) {
              if (seen[id]) return;
              seen[id] = true;
            }
            // Dawn's reveal-on-scroll never sees cards added later; without this they would sit at
            // opacity .01 for up to 7.5s (base.css .scroll-trigger, --animation-order * 75ms).
            li.classList.add('scroll-trigger--cancel');
            var node = document.adoptNode(li);
            if (!firstNew) firstNew = node;
            frag.appendChild(node);
            added++;
          });
          grid.appendChild(frag);

          // Page numbers under the grid now continue from the last page loaded.
          var newBar = doc.querySelector('.mcc-pgbar--bottom');
          var curBar = box.parentNode ? box.parentNode.querySelector('.mcc-pgbar--bottom') : null;
          if (newBar && curBar) {
            stripSectionId(newBar);
            curBar.parentNode.replaceChild(document.adoptNode(newBar), curBar);
          }

          next++;
          hops++;
          step();
        })
        .catch(function (err) {
          // Twice a server answer that isn't the grid: go to the next page instead. A network failure
          // (offline) stays here with "Please try again": navigating would only show the browser's
          // error page and lose the shopper's place.
          // MCC R1 (10/2026) round 4: only navigate when this page already carries the in-stock filter.
          // After a direct arrival without it (ad / email link to a tag URL), theme.liquid's click script
          // adds the filter on the way to page N, which can be an empty page of a smaller result set.
          if (err && err.mccBadResponse && /[?&]filter\.v\.availability=/.test(window.location.search)) {
            try {
              goToNextPage();
              return;
            } catch (e) {}
          }
          finish(true);
        });
    }

    step();
  }

  function initLoadMore() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-mcc-loadmore-btn]');
      if (!btn) return;
      var box = btn.closest('[data-mcc-loadmore]');
      if (!box) return;
      e.preventDefault();
      loadMore(box, btn);
    });
  }

  /* ---------------------------------------------------------------- chips (analytics only) */
  function initChips() {
    document.addEventListener('click', function (e) {
      var chip = e.target.closest && e.target.closest('.mcc-mchip');
      if (!chip) return;
      push({
        event: 'mcc_filter_chip',
        mcc_chip_tag: chip.getAttribute('data-chip-tag') || '',
        mcc_chip_action: chip.classList.contains('is-active') ? 'remove' : 'add'
      });
    });
  }

  /* ---------------------------------------------------------------- boot */
  var booted = false;
  function boot() {
    if (booted) return;
    booted = true;
    try {
      initLoadMore();
      initChips();
      initEditor();
      startSheet();
    } catch (err) {
      ROOT.classList.remove(ON);
      if (window.console && console.error) console.error('[mcc-mobile-filters]', err);
    }
  }

  // Run after the sidebar snippets' own DOMContentLoaded set-up (they move the grid into place).
  // While deferred scripts run, readyState is already "interactive" but DOMContentLoaded has not fired,
  // so wait for it; `load` is the backstop if this file was ever injected after it.
  if (document.readyState === 'complete') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot);
    window.addEventListener('load', boot);
  }
})();
